import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Main from '@/components//views/Main.vue'
import Gsjj from '@/components/views/Gsjj.vue'
import Login from "@/components/Login.vue"
import Skaq from '@/components/views/skaq/index.vue'
Vue.use(Router)

export default new Router({
   mode: 'history',  //去掉url中的#
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [
        // {
        //    path: '/main',
        //    name:'main',
        //    component:Main
        // },
        {
           path: '/views/gsjj',
           name:'gsjj',
           component:Gsjj
        },
        // {
        //   path: '/view/skaq',
        //    name:'skaq',
        //    component:Skaq
        // }
      ]
    },
    // {
    //   path: '/index',
    //   name: 'index',
    //   component: Index
    // },
    // {

    //   name: 'gsjj',
    //   component: Gsjj
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js